import { RotaBuilderFiltersType } from 'screens/Rostering/types'
import { BuilderFilters } from './BuilderFilters'
import { ShiftBuilderFilters } from './ShiftBuilderFilters'
import { User } from '@lmc/ts-common/lib/lists/User'
import { ResidentDtos } from '@lmc/ts-common'
import useMixpanelEvent, { MixpanelEvents } from 'hooks/useMixpanelEvent'
import { useCallback } from 'react'

type RotaFiltersProps = {
  value?: RotaBuilderFiltersType
  onChange?: (value: RotaBuilderFiltersType) => void
  builderType: 'user' | 'resident' | 'shift'
  users?: User[]
  residents?: ResidentDtos[]
  publishedRota?: boolean
}

export const RotaBuilderFilters = ({
  value,
  onChange,
  builderType,
  publishedRota,
}: RotaFiltersProps) => {
  const sendEvent = useMixpanelEvent()

  const handleFilterChange = useCallback(
    (newValue: RotaBuilderFiltersType) => {
      onChange?.(newValue)

      sendEvent(MixpanelEvents.ROTA_FILTERS_APPLIED, {
        builderType,
        publishedRota: !!publishedRota,
        hasTeamMembersFilter: (newValue.teamMembers?.length || 0) > 0,
        hasStatusFilter: (newValue.status?.length || 0) > 0,
        hasServiceUsersFilter: (newValue.serviceUsers?.length || 0) > 0,
        hasWarningsFilter: (newValue.warnings?.length || 0) > 0,
        hasAllocationsFilter: (newValue.allocations?.length || 0) > 0,
        hasRolesFilter: (newValue.roles?.length || 0) > 0,
        hasOvertimeFilter: newValue.overtime !== undefined,
        hasAbsencesFilter: (newValue.absences?.length || 0) > 0,
        hasTypeOfEventFilter: (newValue.typeOfEvent?.length || 0) > 0,
        hasFlexiFilter: (newValue.flexi?.length || 0) > 0,
        hasSiteShiftFilter: newValue.siteShift !== undefined,
      })
    },
    [onChange, sendEvent, builderType, publishedRota],
  )

  switch (builderType) {
    case 'user':
      return (
        <BuilderFilters
          value={value}
          onChange={handleFilterChange}
          builderType={builderType}
          publishedRota={publishedRota}
        />
      )
    case 'resident':
      return (
        <BuilderFilters
          value={value}
          onChange={handleFilterChange}
          builderType={builderType}
          publishedRota={publishedRota}
        />
      )
    case 'shift':
      return (
        <ShiftBuilderFilters
          value={value}
          onChange={handleFilterChange}
          publishedRota={publishedRota}
        />
      )
    default:
      return null
  }
}
